import {
  Component,
  ChangeDetectionStrategy,
  inject,
  computed,
} from '@angular/core';
import { GlossaryOverlayService } from '@core/services/glossary-overlay.service';

/**
 * Shared glossary tooltip overlay (GAP-FU-12).
 *
 * Single instance mounted at app root. Visibility / position driven by
 * `GlossaryOverlayService`. Renders the term name, definition, and
 * see-also list under the hovered acronym.
 */
@Component({
  selector: 'app-glossary-overlay',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './glossary-overlay.component.html',
  styleUrls: ['./glossary-overlay.component.scss'],
})
export class GlossaryOverlayComponent {
  private readonly svc = inject(GlossaryOverlayService);

  protected readonly token = this.svc.token;
  protected readonly entry = this.svc.entry;

  protected readonly position = computed(() => {
    const anchor = this.svc.anchor();
    if (!anchor) return null;
    const viewportW = typeof window !== 'undefined' ? window.innerWidth : 1280;
    const cardWidth = 280;
    const left = Math.min(anchor.left, viewportW - cardWidth - 8);
    const top = anchor.bottom + 6;
    return { left, top };
  });
}
